import { SET_RECOMMENDATIONS } from './actionTypes';

const setRecommendations = recommendations => ({
    type: SET_RECOMMENDATIONS,
    payload: recommendations,
});

export default setRecommendations;
